<template>
  <b-card no-body>
    <b-col class="d-flex justify-content-between px-2 py-1">
      <b-button
        v-b-modal.modal-add-APIKey
        variant="primary"
        :disabled="isLoading"
        size="sm"
      >
        <GjIcon
          class="mr-50"
          name="Plus"
        />
        {{ $tk('ClientPortal.Account.Edit.AddAPIKey') }}
      </b-button>
      <SearchInputField
        class="mb-0"
        :disabled="isLoading"
        :placeholder="$tk('ClientPortal.Form.Search')"
        @onInputSearch="onSearchChange"
      />
    </b-col>
    <div class="client-table--apiKeys">
      <Table
        :data="apiKeys"
        :columns="apiKeysColumns"
        :is-loading="isLoading"
        class="admin-table__data apiKeys-table"
        type-of-table="apiKeys"
        @changePage="changeCurrentPage"
      />
    </div>
    <b-modal
      id="modal-apikey-delete"
      :ok-title="$tk(`ClientPortal.Form.Actions.${model.action}`)"
      :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
      :ok-variant="model.action === 'Regenerate' ? 'success' : 'danger'"
      cancel-variant="outline-secondary"
      centered
      size="sm"
      :title="$tk(`ClientPortal.Admin.${model.action}`) + ' API Key' "
      no-enforce-focus
      @show="getApiKeyModel"
      @ok="deleteAPIKey"
    >
      <div class="d-flex flex-column text-center my-2">
        <span>
          {{ $tk('ClientPortal.Client.ApiKey.AreYouSureYouWantTo') + ' ' + $tk(`ClientPortal.Client.ApiKey.${model.action}`) }}
        </span>
        <span>
          {{ ` "${model.displayName}"`+' API Key' }}
        </span>
      </div>
    </b-modal>
    <b-modal
      id="modal-apikey-success"
      v-model="showSuccessModal"
      centered
      size="md"
      no-enforce-focus
      hide-footer
      header-class="pb-0"
      body-class="border-top-0"
    >
      <div class="d-flex flex-column text-center mb-2">
        <span>
          <GjIcon
            class="text-success"
            size="60"
            name="Checkmark_fill"
          />
        </span>
        <span>
          {{ $tk('ClientPortal.Client.ApiKey.YourKeyWasSuccessfullyGenerated') }}
        </span>
      </div>
      <div class="successModal-content">
        <b-card
          class="bg-light mb-2"
          no-body
        >
          <div class="d-flex flex-column p-1">
            <span class="mb-1 text-muted">
              {{ $tk('ClientPortal.Client.APIKey') }}
            </span>
            <span class="mb-1">
              {{ key }}
            </span>
            <b-button
              variant="link-secondary"
              size="sm"
              class="justify-content-start text-muted pl-0"
              @click="copyKey"
            >
              <GjIcon
                class="mr-50"
                name="Copy"
              />
              {{ $tk('ClientPortal.Client.ApiKey.CopyKey') }}
            </b-button>
          </div>

        </b-card>
        <div class="d-flex flex-column">
          <span>
            {{ $tk('ClientPortal.Client.ApiKey.KeepYourKeySafe') }}
          </span>
          <span class="text-muted">
            {{ $tk('ClientPortal.Client.ApiKey.PleaseStoreThisAPIKeySomewhereSinceYouWontBeAbleToSeeItAgain') }}
          </span>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-add-APIKey"
      :title="$tk(`ClientPortal.Account.Edit.${model.id ? 'EditAPIKey' : 'AddAPIKey'}`)"
      :ok-title="$tk('ClientPortal.Form.Actions.Save')"
      :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="md"
      no-enforce-focus
      :ok-disabled="saving || !isFormComplete()"
      @show="getApiKeyModel"
      @ok="addAPIKey"
    >
      <b-form-group
        class="mb-2 mt-50"
        :label="$tk('ClientPortal.Account.Edit.DisplayName') + ' *'"
        :invalid-feedback="errors['DisplayName']"
      >
        <b-form-input
          v-model="model.displayName"
          :placeholder="$tk('ClientPortal.Form.DisplayNamePlaceholder')"
          size="sm"
          type="text"
          :state="errors['DisplayName'] == null ? null : false"
        />
      </b-form-group>
      <b-form-group
        :label="$tk('ClientPortal.Account.Edit.RoleofAPI')+ ' *'"
        class="mb-0"
      >
        <div
          v-for="role in userRoles"
          :key="role.id"
        >
          <b-form-radio
            v-if="role.editable"
            v-model.number="model.roleId"
            :disabled="model.id ? true : false"
            class="mb-1"
            :value="role.id"
          >
            <div class="text-dark mb-50">
              {{ role.name }}
            </div>
            <span class="text-secondary">
              {{ role.description }}
            </span>
          </b-form-radio>
        </div>
      </b-form-group>
      <b-form-checkbox
        v-model="model.hasExpirationDate"
        checked="false"
        :disabled="model.id ? true : false"
        name="check-button"
        switch
      >
        <div
          class="d-flex flex-column"
        >
          {{ $tk('ClientPortal.Account.Edit.ExpirationDate') }}
          <span
            class="text-secondary"
            @click.prevent
          >
            {{ $tk('ClientPortal.Account.Edit.IfDateIsNotSelectedByDefaultTheExpirationDateIs6MonthsFromCurrentDate') }}
          </span>
        </div>
      </b-form-checkbox>
      <div
        v-if="model.hasExpirationDate"
        class="d-flex flex-column"
      >
        <span class="mb-50">
          {{ $tk('ClientPortal.Account.Edit.ChooseDateOfExpiration') }}
        </span>
        <b-dropdown
          ref="dateDropdown"
          menu-class="py-0"
          right
          variant="outline-dark"
          no-caret
        >
          <template #button-content>
            <span class="d-flex w-100 justify-content-between align-items-center">
              {{ model.expirationDate ? customFormatter(model.expirationDate) : $tk('ClientPortal.Account.Edit.SelectDate') }}
              <GjIcon
                name="Calendar"
                class="ml-50"
              />
            </span>
          </template>
          <div>
            <vuejs-datepicker
              v-model="model.expirationDate"
              bootstrap-styling
              :inline="true"
              :disabled-dates="{
                to: new Date(Date.now() - 8640000)
              }"
              :use-utc="false"
              :format="customFormatter"
            />
          </div>
        </b-dropdown>
        <span class="my-50 text-danger">
          {{ errors['ExpirationDate'] }}
        </span>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import notification from '@/mixins/toastification'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import SearchInputField from '@/components/SearchInputField.vue'
import Table from '@/components/Table.vue'
import translation from '@/mixins/translate'
import APIKeysService from '@/api/client/apiKeys.service'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import store from '@/store'
import { useClipboard } from '@vueuse/core'
import {
  onMounted,
  ref,
  computed,
  watch,
} from '@vue/composition-api'

export default {
  components: {
    GjIcon,
    SearchInputField,
    Table,
    vuejsDatepicker,
  },
  mixins: [notification],
  setup(_, context) {
    const apiKeysColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.ApiKeys.Name'),
        field: 'displayName',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.ApiKeys.Role'),
        field: 'roleId',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.ApiKeys.Status'),
        field: 'status',
        sortable: false,
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.ApiKeys.ExpirationDate'),
        field: 'expirationDate',
        sortable: false,
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.ApiKeys.Details'),
        field: 'details',
        sortable: false,
      },
    ]
    const isLoading = ref(false)
    const accountId = computed(() => context.root.$route.params.accountId)
    const apiKeys = computed(() => store.getters.apiKeys)
    const userRoles = computed(() => store.getters.getUserRoles)
    const errors = ref({})
    const model = ref({})
    const page = ref(0)
    const searchTerm = ref('')
    const saving = ref(false)
    const showSuccessModal = ref(false)
    const { copy } = useClipboard()
    const key = ref('')
    watch([accountId, page, searchTerm], async () => {
      await store.dispatch('getAPIKeys', { accountId: accountId.value, page: page.value, searchTerm: searchTerm.value })
    })
    const customFormatter = date => moment(date).format('DD-MM-YYYY')

    const getApiKeyModel = () => {
      model.value = store.getters.getApiKeyModel
      errors.value = {}
      store.commit('SET_API_KEY_MODEL', {})
    }

    const changeCurrentPage = async value => {
      page.value = value - 1
    }

    const isFormComplete = () => {
      const { displayName, roleId } = model.value
      return displayName && roleId
    }

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getAPIKeys', { accountId: accountId.value })
      isLoading.value = false
    })

    const rowAnimation = () => {
      const newRow = Array.from(document.querySelectorAll('.apiKeys-table > .vgt-wrap > .vgt-inner-wrap > .vgt-responsive > table > tbody > tr:first-child')).pop()
      newRow.classList.remove('table-row-animation')
      // eslint-disable-next-line no-unused-expressions
      newRow.offsetHeight // trigger reflow
      newRow.classList.add('table-row-animation')
    }

    const addAPIKey = async bvModalEvt => {
      bvModalEvt.preventDefault()
      saving.value = true
      let response = null
      try {
        response = await APIKeysService.saveAPIKey(model.value, accountId.value)
        if (response.saved) {
          bvModalEvt.vueTarget.hide('modal-add-APIKey')
          key.value = response.plainKey
          showSuccessModal.value = !!response.plainKey
          notification.methods.success(response.message)
          errors.value = response.errors
          if (response.plainKey) {
            rowAnimation()
          }
        } else {
          notification.methods.error(response.message)
          errors.value = response.model.errors
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        await store.dispatch('getAPIKeys', { accountId: accountId.value, page: page.value, searchTerm: searchTerm.value })
        saving.value = false
      }
    }

    const deleteAPIKey = async () => {
      let response = null
      try {
        if (model.value.action === 'Delete') {
          response = await APIKeysService.delete(model.value, accountId.value)
        } else if (model.value.action === 'Revoke') {
          response = await APIKeysService.revoke(model.value, accountId.value)
        } else {
          response = await APIKeysService.regenerate(model.value, accountId.value)
        }
        if (response.saved) {
          notification.methods.success(response.message)
          if (response.plainKey) {
            key.value = response.plainKey
            showSuccessModal.value = !!response.plainKey
          }
        } else {
          notification.methods.error(response.message)
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        await store.dispatch('getAPIKeys', { accountId: accountId.value, page: page.value, searchTerm: searchTerm.value })
      }
    }

    const onSearchChange = async value => {
      searchTerm.value = value
    }

    const copyKey = () => {
      copy(key.value)
      notification.methods.success(translation.methods.$tk('ClientPortal.Admin.ApiKeys.KeyCopied'))
    }

    return {
      apiKeysColumns,
      onSearchChange,
      apiKeys,
      isLoading,
      userRoles,
      errors,
      model,
      addAPIKey,
      customFormatter,
      saving,
      getApiKeyModel,
      key,
      showSuccessModal,
      copyKey,
      changeCurrentPage,
      isFormComplete,
      deleteAPIKey,
    }
  },
}
</script>
<style lang="scss">
@import '@/assets/scss/views/added_row_animation.scss';
.apiKeys-table{
  .empty-state {
    height: calc(100vh - 351.5px);
  }
}
.successModal-content{
  font-size: 14px;
  font-weight: 500;
}
</style>
